__turbopack_context__.v({
  "className": "montserrat_436c5685-module__ye_xMG__className",
  "variable": "montserrat_436c5685-module__ye_xMG__variable",
});
